module.exports = __webpack_public_path__ + "img/checked-icon-white.fd475dd0.svg";